module.exports = __webpack_public_path__ + "img/mdh6.300cf7d2.jpg";